import { createTheme, darken, lighten } from "@mui/material/styles";
import "@fontsource/jost/400.css";
import "@fontsource/inter/300.css";
import "@fontsource/inter/400.css";
import "@fontsource/inter/500.css";
import "@fontsource/inter/600.css";
import "@fontsource/inter/700.css";
import "@fontsource/poppins/200.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource-variable/lexend-deca";
import { colors } from "./tokens";

const theme = createTheme({
  typography: {
    allVariants: {
      fontFamily: "Inter, sans-serif",
    },
  },
});

const breakpoint = theme.breakpoints.down("sm");

const themeLight = createTheme(theme, {
  palette: {
    mode: "light",
    primary: {
      main: colors.primary.main,
      light: colors.primary.light,
      lighter: colors.primary.lighter,
      contrastText: colors.primary.contrastText,
    },
    secondary: {
      main: colors.secondary.main,
      dark: darken(colors.secondary.main, 0.2),
      light: lighten(colors.secondary.main, 0.9),
      contrastText: colors.secondary.contrastText,
    },
    text: {
      primary: colors.text.primary,
      helper: colors.text.helper,
    },
    purple: {
      main: colors.purple.main,
      light: colors.purple.light,
      dark: colors.purple.dark,
      contrastText: colors.purple.contrastText,
    },
    yellow: {
      main: colors.yellow.main,
      light: colors.yellow.light,
      contrastText: colors.yellow.contrastText,
    },
    black: {
      main: colors.black.main,
      light: colors.black.light,
      contrastText: colors.black.contrastText,
    },
    success: {
      ...theme.palette.success,
      main: colors.success.main,
      dark: colors.success.dark,
      border: colors.success.border,
      contrastText: colors.success.contrastText,
    },
    divider: theme.palette.grey[500], // #9e9e9e
    border: theme.palette.grey[300], // #e0e0e0
  },
  typography: {
    fontFamily: "Inter, sans-serif",
    h1: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "32px",
      fontWeight: "400",
    },
    h2: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "24px",
      fontWeight: "400",
    },
    h3: {
      fontFamily: "Poppins, sans-serif",
      fontSize: "20px",
      fontWeight: "500",
    },
    h4: {
      fontSize: "15px",
      fontWeight: "400",
    },
    h5: {
      fontSize: "12px",
      fontWeight: "400",
    },
    h6: {
      fontSize: "11px",
      fontFamily: "Poppins, sans-serif",
    },
    subtitle1: {
      fontWeight: "500",

      [breakpoint]: {
        fontSize: "0.9rem",
      },
    },
    body1: {
      fontSize: "0.875rem", // "0.9375rem",
      fontWeight: "300",
      lineHeight: 1.8,
    },
    body2: {
      fontWeight: "300",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "Inter, sans-serif",
          fontWeight: "400",
          fontSize: "15px",
          textTransform: "none",
          borderRadius: "4px",
          padding: "8px 32px",
          boxShadow: "none",
          letterSpacing: 0,
        },
      },
    },
    MuiDialogTitle: {
      root: {
        fontSize: "24px",
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        html: {
          scrollBehavior: "smooth",
        },
        ".cookie-consent": {
          display: "none",
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          zIndex: "9999",
          padding: "10px 20px",
          backgroundColor: colors.cookieConsentBg,
          width: "100%",
          borderTop: `1px solid ${colors.cookieConsentBorder}`,
          textAlign: "center",
          "& button": {
            borderRadius: "4px",
            borderColor: "transparent",
            cursor: "pointer",
          },

          "&.show": {
            display: "block",
          },
        },
        a: {
          textDecoration: "underline",
          color: colors.linkColor,
          cursor: "pointer",
          "&:hover": {
            textDecoration: "none",
          },
        },
      },
    },
  },
});

export default themeLight;

export const publicTheme = createTheme(themeLight, {
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "2px",
          fontWeight: "400",
          fontSize: "14.5px",
        },
      },
    },
  },
});
